import React, { useState,useEffect } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Tooltip } from "react-tooltip";
import CheckCurrentPlan from "../../../../components/CheckCurrentPlan";
import { updateTemplateDetail,submitTemplate } from "../../../../utils/logoShowcaseApi";
import '../../../../assets/css/loader.css'; 

//Import Widgets
import LogoShowcaseTemplateWidget from "../../../../components/Apps/LogoShowcase/Template/LogoShowcaseTemplateWidget";

//Import Tabs
import ContentTab from "../../../../components/Apps/LogoShowcase/ContentTab";
import LayoutTab from "../../../../components/Apps/LogoShowcase/LayoutTab";
import StyleTab from "../../../../components/Apps/LogoShowcase/StyleTab";

export default function CreateLogoShowcase() {
    const navigate = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(true);
    const [showTemplateSelection, setShowTemplateSelection] = useState(true);
    const [activeSection, setActiveSection] = useState("Content");
    const [activeTemplateSection, setActiveTemplateSection] = useState("Infinite_Carousel_Temp");
    const [selectedLayout, setSelectedLayout] = useState("infinite_carousel_layout");
    const [selectedTemplateImage, setSelectedTemplateImage] = useState("infinite-carousel.png");
    const [renameWidgetNameModel, setRenameWidgetNameModel] = useState(false);
    const [widgetName, setWidgetName] = useState("Untitled Logo Showcase");
    const [newWidgetName, setNewWidgetName] = useState("");
    const [isTemplateId, setTemplateId] = useState(null); 
    const [refreshWidgetList, setRefreshWidgetList] = useState(false);
    
    const [logoShowcaseTabData, setLogoShowcaseTabData] = useState({
        is_website_frontend: "",  
        is_show_header: 1,     
        header_title: "",     
        header_caption: "",  
        is_show_action_button: 0,     
        action_link: "",     
        action_text: "Contact Us",     
        sidebar_layout_type: "",     
        logo_size: "",     
        spacing_between_logo: "",     
        font_type: "Default",     
        background_color: "",     
        logo_custom_color: "",     
        logo_background_color: "",  
        position_alignment: "center",  
        header_title_color: "",     
        header_caption_color: "",   
        button_color: "",   
        button_text_color: "",   
        header_link_color: "",   
        header_title_font_size: "24px",   
        header_caption_font_size: "16px",
        button_font_size: "16px",      
        custom_css: "",   
        custom_js: "",   
    });

    // Set Template Setting And Texts when activeTemplateSection changes
        useEffect(() => {
            let header_title = "";
            let header_caption = "";
            let sidebar_layout_type = "";
            let logo_size = "";
            let spacing_between_logo = "";
            let background_color = "";
            let logo_custom_color = "";
            let logo_background_color = "";
            let header_title_color = "";
            let header_caption_color = "";
            let header_link_color = "";
            let button_color = "";
            let button_text_color = "";
        
            switch (activeTemplateSection) {
                case "Infinite_Carousel_Temp":
                    header_title = "";
                    header_caption = "";
                    sidebar_layout_type = "Ticker";
                    logo_size = "50px";
                    spacing_between_logo = "10px";
                    background_color = "#f8f8f8";
                    logo_custom_color = "#f8f8f8";
                    logo_background_color = "#f8f8f8";
                    header_title_color = "#000";
                    header_caption_color = "#000";
                    header_link_color = "#000";
                    button_color = "#fff";
                    button_text_color = "#000";
                    break;
                case "Infinite_Monochrome_Carousel_Temp":
                    header_title = "";
                    header_caption = "";
                    sidebar_layout_type = "Ticker";
                    logo_size = "50px";
                    spacing_between_logo = "10px";
                    background_color = "#bdb4b4";
                    logo_custom_color = "#bdb4b4";
                    logo_background_color = "#bdb4b4";
                    header_title_color = "#000";
                    header_caption_color = "#000";
                    header_link_color = "#000";
                    button_color = "#fff";
                    button_text_color = "#000";
                    break;
                case "Logo_Slider_Temp":
                    header_title = "Some of our clients";
                    header_caption = "";
                    sidebar_layout_type = "Carousel";
                    logo_size = "50px";
                    spacing_between_logo = "10px";
                    background_color = "#f8f8f8";
                    logo_custom_color = "#f8f8f8";
                    logo_background_color = "#f8f8f8";
                    header_title_color = "#000";
                    header_caption_color = "#000";
                    header_link_color = "#000";
                    button_color = "#fff";
                    button_text_color = "#000";
                    break;
                case "Logo_Grid_Temp":
                    header_title = "Our Clients";
                    header_caption = "";
                    sidebar_layout_type = "Grid";
                    logo_size = "50px";
                    spacing_between_logo = "10px";
                    background_color = "#f8f8f8";
                    logo_custom_color = "transparent";
                    logo_background_color = "#f8f8f8";
                    header_title_color = "#000";
                    header_caption_color = "#000";
                    header_link_color = "#000";
                    button_color = "#fff";
                    button_text_color = "#000";
                    break;
                case "Dark_Infinite_Carousel_Temp":
                    header_title = "";
                    header_caption = "";
                    sidebar_layout_type = "Ticker";
                    logo_size = "50px";
                    spacing_between_logo = "10px";
                    background_color = "#000";
                    logo_custom_color = "#fff";
                    logo_background_color = "#000";
                    header_title_color = "#fff";
                    header_caption_color = "#fff";
                    header_link_color = "#fff";
                    button_color = "#fff";
                    button_text_color = "#000";
                    break;
                case "Partners_Temp":
                    header_title = "Our Partners";
                    header_caption = "We work with the most influential companies in the field. Meet our partners.";
                    sidebar_layout_type = "Grid";
                    logo_size = "50px";
                    spacing_between_logo = "10px";
                    background_color = "#f8f8f8";
                    logo_custom_color = "#fff3d0";
                    logo_background_color = "#fff3d0";
                    header_title_color = "#000";
                    header_caption_color = "#000";
                    header_link_color = "#000";
                    button_color = "#fff";
                    button_text_color = "#000";
                    break;
                default:
                    header_title = "";
                    header_caption = "";
                    sidebar_layout_type = "";
                    logo_size = "";
                    spacing_between_logo = "";
                    background_color = "";
                    logo_custom_color = "";
                    logo_background_color = "";
                    header_title_color = "";
                    header_caption_color = "";
                    header_link_color = "";
                    button_color = "";
                    button_text_color = "";
            }
        
            // Update setQRCodeTabData state with the data
            setLogoShowcaseTabData((prevData) => ({
                ...prevData,
                header_title: header_title,
                header_caption: header_caption,
                sidebar_layout_type: sidebar_layout_type,
                logo_size: logo_size,
                spacing_between_logo: spacing_between_logo,
                background_color: background_color,
                logo_custom_color: logo_custom_color,
                logo_background_color: logo_background_color,
                header_title_color: header_title_color,
                header_caption_color: header_caption_color,
                header_link_color: header_link_color,
                button_color: button_color,
                button_text_color: button_text_color,
            }));
        
        }, [activeTemplateSection]);

    // Open Widget Name Popup
    const openRenameWidgetNamePopup = () => {
        setNewWidgetName(widgetName);
        setRenameWidgetNameModel(true);
        document.body.classList.add("popup-open");
    };

    // Close Widget Name Popup
    const closeRenameWidgetNamePopup = () => {
        setRenameWidgetNameModel(false);
        document.body.classList.remove("popup-open");
    };

    // Save Widget Name Popup
    const saveWidgetName = () => {
        if (newWidgetName.trim() !== "") {
            setWidgetName(newWidgetName); 
        }
        closeRenameWidgetNamePopup();
    };

    // Function to update values dynamically
    const updateLogoShowcaseTabData = (key, value) => {
        setLogoShowcaseTabData((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    const handleContinueTemplate = () => {
      setShowTemplateSelection(false);
      setIsSubmitting(false);
      //Get the currently checked radio button
      const selectedRadio = document.querySelector('input[name="app_template_type"]:checked');
      if (selectedRadio) {
          const layoutTypeValue = selectedRadio.dataset.layout_type;
          setSelectedLayout(layoutTypeValue);
      } else {
          alert('Please select a template');
      }
  }; 

  const menuItems = [
      { key: "Content", icon: "content.png", label: "Content" },
      { key: "Layout", icon: "layout.png", label: "Layout" },
      { key: "Style", icon: "style.png", label: "Style" },
  ];

  // Handle Source Tab input change
  const handleActiveTemplateInputChange = (event) => {
      setActiveTemplateSection(event.target.value);
      //Get the currently checked radio button
      const selectedRadio = document.querySelector('input[name="app_template_type"]:checked');
      if (selectedRadio) {
          const layoutTypeValue = selectedRadio.dataset.layout_type;
          const template_image = selectedRadio.dataset.template_image;
          setSelectedLayout(layoutTypeValue);
          setSelectedTemplateImage(template_image);
      } else {
          alert('Please select a template');
      }
    };

    //Update Form data
    const updateForm = async (e) => {
        e.preventDefault();

        setIsSubmitting(true);
        try {
            // Convert settings object back into an array of key-value pairs
            const updateSettingsArray = Object.entries(logoShowcaseTabData).map(([key, value]) => ({
                setting_key: key,
                setting_value: value,
            }));

            // Collect data from refs
            const payload = {
                template_id: isTemplateId,
                name: widgetName,
                template_name: activeTemplateSection,
                template_image: selectedTemplateImage,
                layout_name: selectedLayout,
                layout_type: selectedLayout,
                settings: updateSettingsArray,
            };
            
            //Api Call
            let api_response = await updateTemplateDetail(payload);
            setIsSubmitting(false);
            //Check Responce
            if (api_response.status === true) {
                toast.success("Submitted Successfully.");
                // Redirect after 2 seconds
                setTimeout(() => {
                    navigate('/customer/apps/logo-showcase');
                }, 2000); 
            } else {
                toast.error(api_response.message);
            }
        } catch (error) {
            toast.error('Oops Something Wrong. Please Try Again!' + error.message);
        }
    };

    //Submit Review data
    const submitForm = async (e) => {
        e.preventDefault();

        setIsSubmitting(true);
        try {
        // Collect data from refs
        const settingsArray = Object.entries(logoShowcaseTabData).map(([key, value]) => ({
            setting_key: key,
            setting_value: value,
        }));

            // Collect data from refs
            const payload = {
                name: widgetName,
                template_name: activeTemplateSection,
                template_image: selectedTemplateImage,
                layout_name: selectedLayout,
                layout_type: selectedLayout,
                app_type: "Logo_Showcase",
                settings: settingsArray,
            };
            
            //Api Call
            let api_response = await submitTemplate(payload);

            //Check Responce
            if (api_response.status === true) {
                toast.success(api_response.message);
                // Redirect after 2 seconds
                setTimeout(() => {
                    navigate('/customer/apps/logo-showcase');
                }, 2000); 
            } else {
                toast.error(api_response.message);
            }
        } catch (error) {
            toast.error('Oops Something Wrong. Please Try Again!' + error.message);
        } finally {
            setIsSubmitting(false);
        }
    };

  return (
    <>
      <div className="create-goole-reviews-all">
            <CheckCurrentPlan from_page={true} app_name="Logo Showcase" app_type="Logo_Showcase" app_slug="logo-showcase"/>
            {showTemplateSelection ? (
                <div className="create-goole-reviews-side">
                    <span>Select a template to start with</span>
                    <div className="card h-100">
                        <div className="label-box-flex">
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Infinite_Carousel_Temp" data-layout_type="infinite_carousel_layout" data-template_image="infinite-carousel.png" checked={activeTemplateSection === "Infinite_Carousel_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className="card card-body">
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/logo-showcase/templates/infinite-carousel.png`} alt="infinite-carousel" />
                                    </div> 
                                    <div className="content_sub">Infinite Carousel</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Infinite_Monochrome_Carousel_Temp" data-layout_type="infinite_monochrome_carousel_layout" data-template_image="infinite-monochrome-carousel.png" checked={activeTemplateSection === "Infinite_Monochrome_Carousel_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className="card card-body">
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/logo-showcase/templates/infinite-monochrome-carousel.png`} alt="infinite-monochrome-carousel" />
                                    </div> 
                                    <div className="content_sub">Infinite Monochrome Carousel</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Logo_Slider_Temp" data-layout_type="logo_slider_layout" data-template_image="logo-slider.png" checked={activeTemplateSection === "Logo_Slider_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className="card card-body">
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/logo-showcase/templates/logo-slider.png`} alt="logo-slider" />
                                    </div> 
                                    <div className="content_sub">Logo Slider</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Logo_Grid_Temp" data-layout_type="logo_grid_layout" data-template_image="logo-grid.png" checked={activeTemplateSection === "Logo_Grid_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className="card card-body">
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/logo-showcase/templates/logo-grid.png`} alt="logo-grid" />
                                    </div> 
                                    <div className="content_sub">Logo Grid</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Dark_Infinite_Carousel_Temp" data-layout_type="dark_infinite_carousel_layout" data-template_image="dark-infinite-carousel.png" checked={activeTemplateSection === "Dark_Infinite_Carousel_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className="card card-body">
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/logo-showcase/templates/dark-infinite-carousel.png`} alt="dark-infinite-carousel" />
                                    </div> 
                                    <div className="content_sub">Dark Infinite Carousel </div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Partners_Temp" data-layout_type="partners_layout" data-template_image="partners.png" checked={activeTemplateSection === "Partners_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className="card card-body">
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/logo-showcase/templates/partners.png`} alt="partners" />
                                    </div> 
                                    <div className="content_sub">Partners</div>
                                </div>
                            </label>
                        </div>
                    </div>
                    <div className="continue-template">
                        <button onClick={handleContinueTemplate}>Continue with this template</button>
                    </div>
                </div>
            ) : (
                <>
                    <div className="overlay-side-baar">
                        <div className="side-baar-inner-one">
                            <ul>
                                {menuItems.map((item) => (
                                    <li key={item.key}>
                                        <button
                                            className={activeSection === item.key ? "active" : ""}
                                            onClick={() => setActiveSection(item.key)}
                                        >
                                            <img
                                                src={`${process.env.PUBLIC_URL}/logo-showcase/icons/${item.icon}`}
                                                alt={`${item.key} icon`}
                                            />
                                            <span>{item.label}</span>
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="side-baar-inner-tow">
                            {/* Conditional Rendering for Sections */}
                            {activeSection === "Content" && (
                              <ContentTab isTemplateId={isTemplateId} setTemplateId={setTemplateId} widgetName={widgetName} template_name={activeTemplateSection} template_image={selectedTemplateImage} layout_name={selectedLayout} layout_type={selectedLayout} updateLogoShowcaseTabData={updateLogoShowcaseTabData} logoShowcaseTabData={logoShowcaseTabData} setRefreshWidgetList={setRefreshWidgetList} />
                            )}
                            {activeSection === "Layout" && (
                              <LayoutTab updateLogoShowcaseTabData={updateLogoShowcaseTabData} logoShowcaseTabData={logoShowcaseTabData} />
                            )}
                            {activeSection === "Style" && (
                              <StyleTab updateLogoShowcaseTabData={updateLogoShowcaseTabData} logoShowcaseTabData={logoShowcaseTabData} />
                            )}
                        </div>
                    </div>
                </>
            )}
            <div className="create-goole-reviews-right">
                <div className="content-wrapper count-add-class">
                    <div className="source-header-row">
                        <h2><Link to="/customer/apps/logo-showcase"><i className="fa fa-angle-left" aria-hidden="true"></i> Back</Link></h2>
                        <div className="untitled-widget-name">
                            <button onClick={openRenameWidgetNamePopup} data-tooltip-id="rename-tooltip"><img src={`${process.env.PUBLIC_URL}/logo-showcase/logo-showcase.svg`} alt="logo-showcase"/>{ widgetName }</button>
                            <Tooltip id="rename-tooltip" place="top" content="Rename Widget" />
                        </div>
                        <div className='submit-google-review'>
                          <button type="button" onClick={isTemplateId ? updateForm : submitForm} className={`form-button ${isSubmitting ? 'disabled' : ''}`} disabled={isSubmitting}>Publish</button>
                          <Link to="/customer/apps/logo-showcase/pricing/single" className="view-plan">View Plans</Link>
                          <Link to="/customer/apps/logo-showcase" className="close-button">Close</Link></div> 
                    </div>
                    <div className="source-title-row">Logo Showcase <i className="fa fa-angle-right" aria-hidden="true"></i> <strong>Connect</strong></div>

                    {/*Call Common template*/}
                    <LogoShowcaseTemplateWidget selectedTemplate={activeTemplateSection} isTemplateId={isTemplateId} logoShowcaseTabData={logoShowcaseTabData} refreshWidgetList={refreshWidgetList} />
                </div>
            </div>
        </div>

        {/* Rename Popup */}
        {renameWidgetNameModel && (
            <div className="fixed top-50 left-50 w-full h-full bg-opacity-50 flex justify-center items-center popup-main rounded overflow-hidden widget-rename-model">
                <div className="bg-white p-3 rounded-lg shadow-lg">
                    <h3 className="text-lg font-semibold">Rename Widget</h3>
                    <label>Widget Name</label>
                    <input
                        type="text"
                        className="border p-2 w-full mt-2"
                        value={newWidgetName}
                        onChange={(e) => setNewWidgetName(e.target.value)}
                    />
                    <div className="mt-3 flex justify-end">
                        <button className="px-3 py-1 bg-gray-200 rounded mr-2" onClick={closeRenameWidgetNamePopup}>
                            Cancel
                        </button>
                        <button type="button" className="px-3 py-1 bg-blue-500 text-white rounded" onClick={saveWidgetName}>
                            Save
                        </button>
                    </div>
                </div>
            </div>
        )}
    </>
  );
} 